import {useMemo, useReducer} from 'react';

import {Message} from './types';

export type State = {
	id?: string
	messages: Message[]
	pending?: boolean
	counter?: number
	error?: boolean
}

export type Action =
  | { type: 'SEND', message: string, counter: number }
  | { type: 'RESULT', id: string, messages: Message[], counter: number }
  | { type: 'ERROR', counter: number }
;

type Parser = (m: Message) => Message

const passthru: Parser = (m) => m;

const reducer = (parser?: Parser) => (state: State, action: Action): State => {
	switch (action.type) {
	case 'SEND': {
		const messages: Message[] = [
			...state.messages,
			{
				id: `<local:${state.messages.length}>`,
				source: 'USER',
				message: action.message,
				created: {
					unix: 0,
				},
			},
		];

		return {
			...state,
			messages: messages.map(parser || passthru),
			counter: action.counter,
			pending: true,
			error: false,
		};
	}

	case 'RESULT':
		if (action.counter === state.counter) {
			return {
				...state,
				id: state.id || action.id,
				messages: action.messages.map(parser || passthru),
				pending: false,
			};
		}
		return {...state};

	case 'ERROR':
		if (action.counter === state.counter) {
			return {
				...state,
				pending: false,
				error: true,
			};
		}
		return {...state};
	}
};

export const useState = (parser?: Parser) => {
	const memo = useMemo(() => reducer(parser), [parser]);
	return useReducer(memo, {messages: []});
};
